import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import './assets/tailwind.css'
import axios from 'axios'
import VueAxios from 'vue-axios'

// Deteksi lingkungan secara otomatis
const isLocalhost = window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1' ||
  window.location.hostname.startsWith('192.168.') ||
  window.location.hostname.startsWith('10.0.') ||
  window.location.hostname.endsWith('.local') ||
  window.location.hostname === '[::1]'

// Set baseURL berdasarkan lingkungan
axios.defaults.baseURL = isLocalhost
  ? 'http://localhost:8888/fprint/'
  : 'https://f-print.id/'

// Untuk debugging (opsional)
console.log(`Running in ${isLocalhost ? 'development' : 'production'} mode`)
console.log(`API baseURL set to: ${axios.defaults.baseURL}`)

// Auto-logout: intercept API responses with invalid token
axios.interceptors.response.use(
  function (response) {
    if (response.data && response.data.status === false &&
      (response.data.message === 'Invalid token' || response.data.message === 'Token required')) {
      localStorage.removeItem('X-FPRINT-TOKEN')
      localStorage.removeItem('X-FPRINT-USER')
      store.dispatch('set_token', null)
      store.dispatch('set_user', null)
      if (router.currentRoute.value.name !== 'Login') {
        router.push({ name: 'Login' })
      }
    }
    return response
  },
  function (error) {
    return Promise.reject(error)
  }
)

createApp(App)
  .use(store)
  .use(router)
  .use(VueAxios, axios)
  .mount('#app')
